import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/game/level/cylinder.png';
import _imports_1 from '@/assets/images/game/level/bottomBg0.png';
import _imports_2 from '@/assets/images/game/level/cartoonHead0-1.png';
import _imports_3 from '@/assets/images/game/level/cartoonHead0-3.png';
import _imports_4 from '@/assets/images/game/level/cartoonHead0-2.png';
import _imports_5 from '@/assets/images/game/level/bottomBg1.png';
import _imports_6 from '@/assets/images/game/level/cartoonHead1-1.png';
import _imports_7 from '@/assets/images/game/level/cartoonHead1-2.png';
import _imports_8 from '@/assets/images/game/level/cartoonHead1-3.png';
import _imports_9 from '@/assets/images/game/level/bottomBg2.png';
import _imports_10 from '@/assets/images/game/level/cartoonHead2-1.png';
import _imports_11 from '@/assets/images/game/level/cartoonHead2-2.png';
import _imports_12 from '@/assets/images/game/level/cartoonHead2-3.png';
import _imports_13 from '@/assets/images/game/level/bottomBg3.png';
import _imports_14 from '@/assets/images/game/level/cartoonHead3-1.png';
import _imports_15 from '@/assets/images/game/level/cartoonHead3-2.png';
import _imports_16 from '@/assets/images/game/level/cartoonHead3-3.png';
const _withScopeId = n => (_pushScopeId("data-v-26d5b85a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slide"
};
const _hoisted_2 = {
  class: "slide-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "cylinder"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cylinder-img",
  src: _imports_0,
  alt: "lock",
  draggable: "false"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "slide-footer"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bottomBg",
  src: _imports_1,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead0-1",
  src: _imports_2,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead0-2",
  src: _imports_3,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead0-3",
  src: _imports_4,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_13 = [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12];
const _hoisted_14 = {
  class: "slide-footer"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bottomBg",
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead1-1",
  src: _imports_6,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead1-2",
  src: _imports_7,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead1-3",
  src: _imports_8,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_19 = [_hoisted_15, _hoisted_16, _hoisted_17, _hoisted_18];
const _hoisted_20 = {
  class: "slide-footer"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bottomBg",
  src: _imports_9,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead2-1",
  src: _imports_10,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead2-2",
  src: _imports_11,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead2-3",
  src: _imports_12,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_25 = [_hoisted_21, _hoisted_22, _hoisted_23, _hoisted_24];
const _hoisted_26 = {
  class: "slide-footer"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bottomBg",
  src: _imports_13,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead3-1",
  src: _imports_14,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead3-2",
  src: _imports_15,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cartoonHead3-3",
  src: _imports_16,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_31 = [_hoisted_27, _hoisted_28, _hoisted_29, _hoisted_30];
import { onMounted, ref, watch } from "vue";
import { Swiper, SwiperSlide } from 'swiper/swiper-vue';
import 'swiper/swiper-bundle.css';
export default {
  __name: 'level',
  props: {
    handleSheetClick: Function,
    arrangeNum: Number,
    levelChange: Number
  },
  setup(__props) {
    const props = __props;
    const groupList = ref([]);
    const disableLevels = ref(0);
    const approve = ref([false, false, false, false, false, false, false, false, false, false, false, false]);
    watch(() => props.arrangeNum, newValue => {
      if (newValue) {
        const list = JSON.parse(localStorage.getItem('levelList'));
        groupList.value = list[Number(newValue)].level;
        disableLevels.value = list[Number(newValue)].current;
        approve.value = list[Number(props.arrangeNum)].approve;
      }
    }, {
      deep: true // 开启深度监听
    });

    watch(() => props.levelChange, newValue => {
      if (newValue) {
        const list = JSON.parse(localStorage.getItem('levelList'));
        groupList.value = list[Number(props.arrangeNum)].level;
        disableLevels.value = list[Number(props.arrangeNum)].current;
        approve.value = list[Number(props.arrangeNum)].approve;
      }
    }, {
      deep: true // 开启深度监听
    });

    function handleAnswerPage(i, index) {
      if (index - 1 <= disableLevels.value) {
        localStorage.setItem('groupListName', i);
        localStorage.setItem('groupListIndex', index);
        props.handleSheetClick(3, i, index);
        // 第几关
      }
    }

    onMounted(() => {
      const list = JSON.parse(localStorage.getItem('levelList'));
      groupList.value = list[Number(0)].level;
      disableLevels.value = list[Number(0)].current;
      approve.value = list[Number(props.arrangeNum)].approve;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Swiper), {
        "slides-per-view": 'auto',
        "space-between": 30,
        "grab-cursor": ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, (i, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "box",
            key: i,
            onClick: $event => handleAnswerPage(i, index)
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "box-contain",
              style: _normalizeStyle({
                'background': approve.value[index] === false ? '#D5E2EB' : __props.arrangeNum === 0 ? '#FF017B' : __props.arrangeNum === 1 ? '#02E19B' : __props.arrangeNum === 2 ? '#FFB600' : __props.arrangeNum === 3 ? '#A562FF' : '#D5E2EB'
              })
            }, [_createElementVNode("img", {
              class: "group",
              src: require(`@/assets/images/game/levelCard/${__props.arrangeNum + 1}-${index + 1}.png`),
              alt: "level",
              draggable: "false"
            }, null, 8, _hoisted_3), _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [[_vShow, approve.value.indexOf(false) === index && approve.value.indexOf(false) !== 0 ? index > approve.value.indexOf(false) + 1 : approve.value.indexOf(false) === -1 ? false : index > approve.value.indexOf(false)]])], 4), _createElementVNode("div", {
              class: "title",
              innerHTML: i
            }, null, 8, _hoisted_7)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      })]), _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_13, 512), [[_vShow, __props.arrangeNum === 0]]), _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_19, 512), [[_vShow, __props.arrangeNum === 1]]), _withDirectives(_createElementVNode("div", _hoisted_20, _hoisted_25, 512), [[_vShow, __props.arrangeNum === 2]]), _withDirectives(_createElementVNode("div", _hoisted_26, _hoisted_31, 512), [[_vShow, __props.arrangeNum === 3]])]);
    };
  }
};